import {AbstractPlayableContent} from "../../../playable/models/AbstractPlayableContent";
import {defaultVersion} from "../../../playable/models/Version";

// TODO: Might simplify this using 'NONE' | 'PLAYABLE_CONTENT'
export type LoopType = 'NONE' | 'PLAY' | 'PART' | 'SECTION' | 'RHYTHMIC_BLOC' | 'LIST'

// TODO (v2): Add Support for RhythmicBloc
export const LOOP_TYPES_DISPLAY_VALUES = {
  'NONE': 'Aucune',
  'PLAY': 'Tout',
  'PART': 'Partie',
  'SECTION': 'Section',
  'RHYTHMIC_BLOC': 'Rythmique',
  'LIST': 'Enchainement'
}

export class LoopParameters {
  readonly type: LoopType;
  readonly playableContent: AbstractPlayableContent

  get isActive() {
    return this.type !== 'NONE';
  }

  constructor(mode: LoopType, playableContent: AbstractPlayableContent) {
    this.type = mode;
    this.playableContent = playableContent;
  }
}
export const defaultLoopParameters = new LoopParameters('NONE', defaultVersion);
